export default __webpack_public_path__ + "static/element-2.url-2f72ef50135da8a82debba77584952a0.svg";